import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbcCore } from '@barthauer/abc/core';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { BceService, GroupPacket } from '@barthauer/abc/management/configuration-explorer';
import { IWizardImportPageComponent } from 'libs/abc/interfaces/core/wizards/import/src/lib/models/config.model';
import { AbcDropDownBoxComponent } from 'libs/abc/ui-components/src/lib/core/src/abc-drop-down-box/abc-drop-down-box.component';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AsciiImportService } from '../../ascii-import.service';
import { AsciiWizardSettingDocument, AsciiWizardTransferObject } from '../../models/import.model';

@Component({
  selector: 'barthauer-abc-setting-selection-page',
  templateUrl: './setting-selection-page.component.html',
  styleUrls: ['./setting-selection-page.component.scss'],
  standalone: false,
})
export class SettingSelectionPageComponent implements OnInit, IWizardImportPageComponent, AfterViewInit {
  @ViewChild('configCombobox', { static: true }) configCombobox!: AbcDropDownBoxComponent;

  private unsubscribe$: Subject<void> = new Subject<void>();

  private _configId?: string;
  @Input() public set configId(id: string | undefined) {
    if (id && this._configId !== id) {
      this._configId = id;
    }
  }
  public get configId(): string | undefined {
    return this._configId;
  }
  selectedDocument: AsciiWizardSettingDocument;
  transferObject: object;
  configGUIItems: AsciiWizardSettingDocument[] = [];
  configDocs: AsciiWizardSettingDocument[] = [];
  USER_CONFIG_SELECT_KEY: string = 'SelectUserConfig';
  public res = ResourceSet.Empty;

  get isValid(): boolean {
    if (this.selectedDocument) {
      return this.selectedDocument.id !== this.USER_CONFIG_SELECT_KEY;
    } else return false;
  }
  get invalidMessage(): string {
    return this.res.get('SelectConfig');
  }

  constructor(
    private asciiImportService: AsciiImportService,
    private bceService: BceService,
    private abcCore: AbcCore,
    private cdr: ChangeDetectorRef,
    private resourceManagerService: ResourceManagerService
  ) {}
  ngAfterViewInit(): void {
    this.configCombobox.abcGrid.showColumnHeaders = false;
    this.configCombobox.abcGrid.filterPanel.visible = false;
    this.configCombobox.abcGrid.filterPanel.filterEnabled = false;
  }

  async ngOnInit() {
    this.res = await this.resourceManagerService.getResourceSet('abc-interfaces-ascii-import');
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    const result = await this.asciiImportService.getWizardSettingDocuments();
    this.configDocs = result?.documents;
    let theOnlySettingFromProfile: AsciiWizardSettingDocument | undefined = undefined;
    if (this.configDocs.length == 1) {
      theOnlySettingFromProfile = this.configDocs[0];
      this.selectedDocument = theOnlySettingFromProfile;
    }
    this.appendUserSelectionMenuItem(theOnlySettingFromProfile, result?.allowCustomDocuments);
  }

  onNext(): void {
    (this.transferObject as AsciiWizardTransferObject).settingDocument = this.selectedDocument;
  }
  onDropdownClosed() {
    const selectedId = this.configCombobox.instance.option('value');
    if (selectedId) {
      if (selectedId !== this.USER_CONFIG_SELECT_KEY) {
        const index = this.configDocs.findIndex((item) => item.id === selectedId);
        this.configId = selectedId;
        this.selectedDocument = this.configDocs[index];
      } else {
        this.selectUserDocumentFromBCE();
      }
    }
  }

  selectUserDocumentFromBCE() {
    this.bceService
      .selectDocument(GroupPacket.GROUP_ID_ASCII)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (data: any) => {
          this.updateConfigItem(data);
        },
        (error) => {
          this.abcCore.error.publish(error);
        }
      );
  }

  private updateConfigItem(data: any) {
    const queryId = data.Id;
    const queryName = data.Designation;
    const newItem: AsciiWizardSettingDocument = {
      name: queryName,
      id: queryId,
    };
    this.appendSelectedConfigItem(newItem);
    this.selectedDocument = newItem;
  }

  private appendSelectedConfigItem(newItem: AsciiWizardSettingDocument) {
    const index = this.configDocs.findIndex((item) => item.id === newItem.id);
    if (index === -1) {
      this.configDocs.push(newItem);
    }

    this.appendUserSelectionMenuItem(newItem, true);
    this.configId = newItem.id;
  }

  private appendUserSelectionMenuItem(
    currentItem: AsciiWizardSettingDocument | undefined,
    allowCustomDocuments: boolean
  ) {
    if (this.configGUIItems) {
      this.configGUIItems = [];
      this.configGUIItems.push(...this.configDocs);

      if (allowCustomDocuments) {
        const txt = this.res.get('SelectConfigShort');
        const userSelectItem: AsciiWizardSettingDocument = {
          name: txt,
          id: this.USER_CONFIG_SELECT_KEY,
        };
        this.configGUIItems.push(userSelectItem);
      }
      if (currentItem) {
        setTimeout(() => {
          this.configCombobox.instance.option('value', currentItem.id);
          this.cdr.detectChanges();
        }, 50);
      }
    }
  }
}
